import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetState } from '../../../store/actions';
import { RootState } from '../../../store/store';

interface CurrentUserState {
  activeCurrentUserId: string | null;
}

const initialState: CurrentUserState = {
  activeCurrentUserId: null,
};

const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setActiveCurrentUserId: (state, { payload }: PayloadAction<string>) => {
      state.activeCurrentUserId = payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(resetState.match, () => initialState);
  },
});

export const selectActiveCurrentUserId = (state: RootState) => state.currentUser.activeCurrentUserId;

export const { setActiveCurrentUserId } = currentUserSlice.actions;

const currentUserReducer = currentUserSlice.reducer;

export default currentUserReducer;
